import { render, staticRenderFns } from "./products.index.compoment.vue?vue&type=template&id=27678c66&scoped=true&"
import script from "./products.index.compoment.vue?vue&type=script&lang=ts&"
export * from "./products.index.compoment.vue?vue&type=script&lang=ts&"
import style0 from "./products.index.compoment.vue?vue&type=style&index=0&id=27678c66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27678c66",
  null
  
)

export default component.exports